<template>
  <div>
    <el-form label-position="right" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="调拨单号" prop="number">
            <el-input disabled v-model="form.number" placeholder="自动生成"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="申请人" prop="applyUserId">
            <el-select
                filterable
                clearable
                v-model="form.applyUserId"
                placeholder="请选择"
                @change="changeBusinessMan($event, 'k81')"
                @keyup.enter.native="
                  enterFns(form.applyUserId, 'k81', 'select')
                "
                ref="k81"
                :disabled="readonly"
              >
                <el-option
                  v-for="emp in emps"
                  :key="emp.employeeId"
                  :label="emp.jobNumber"
                  :value="emp.employeeId"
                >
                  <span style="float: left">{{ emp.jobNumber }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    emp.employeeName
                  }}</span>
                </el-option>
              </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="调拨类型" prop="allocationType">
            <el-select v-model="form.allocationType" :disabled="readonly">
              <el-option
                v-for="type in allocationTypes"
                :key="type.value"
                :label="type.label"
                :value="type.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="转出账号" prop="outFinanceAssetaccountId">
            <el-select v-model="form.outFinanceAssetaccountId" :disabled="readonly">
                <el-option v-for="account in account01" :key="account.assetaccountId" :value="account.assetaccountId" :label="account.account">

                </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="转入账号" prop="inFinanceAssetaccountId">
            <el-select v-model="form.inFinanceAssetaccountId" :disabled="readonly">
                <el-option v-for="account in account02" :key="account.assetaccountId" :value="account.assetaccountId" :label="account.account">

                </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="调拨金额" prop="amount">
            <el-input disabled v-model="form.amount"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item prop="comment" label="备注">
            <el-input
              type="textarea"
              :rows="3"
              v-model="form.comment"
              :disabled="readonly && !commentWriteOnly"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="附件">
            <my-image-upload
              @input="changeFileList6"
              :fileNameLists="fileNameLists6"
              :limit="9"
              :disabled="readonly"
            ></my-image-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="调拨状态" prop="number">
            <el-input disabled v-model="form.allocationStatusShow"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="创建时间" prop="createTime">
            <el-input disabled v-model="form.createTime"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="转出确认人" prop="allocationType">
            <el-input disabled v-model="form.outUserName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="转出确认时间" prop="number">
            <el-input disabled v-model="form.outTime"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="转入确认人" prop="inUserName">
            <el-input disabled v-model="form.inUserName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="转入确认时间" prop="allocationType">
            <el-input disabled v-model="form.inTime"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-divider content-position="left">交账明细</el-divider>
    <waybills
      ref="waybill"
      @calcAmount="calcAmount"
      :financeAssetAccountId="form.outFinanceAssetaccountId"
      :allocationId="allocationId"
      :readonly="readonly"
    ></waybills>
  </div>
</template>

<script>
import MyImageUpload from "@/components/MyImageUpload.vue";
import waybills from "./ccc/waybills.vue";
import FetchWaybill from "./ccc/FetchWaybill.vue";
export default {
  components: {
    waybills,
    FetchWaybill,
    MyImageUpload
  },

  props:{
    allocationId:{
      type:String,
      default(){
        return ''
      }
    },
    readonly:{
      type:Boolean,
      default(){
        return false
      }
    },
    commentWriteOnly:{
      type:Boolean,
      default(){
        return false
      }
    }
  },
  data() {
    return {
      allocationTypes: [
        {
          label: "借支",
          value: "jie_zhi:allocation_type",
        },
        {
          label: "存款",
          value: "cun_kuan:allocation_type",
        },
        {
          label: "取款",
          value: "qu_kuan:allocation_type",
        },
        {
          label: "转账",
          value: "zhuan_zhang:allocation_type",
        },
      ],
      form: {
        allocationId:this.allocationId,
        allocationType: "",
        applyUserId: "",
        amount: "",
        outFinanceAssetaccountId: "",
        inFinanceAssetaccountId: "",
        comment: "",
        fileIds: [],
      },
      fileNameLists6: [],
      emps:[],
      account01:[],
      account02:[]
    };
  },
  mounted(){
    this.getEmps()
    this.GetAssetaccountList()
    if(this.allocationId){
      this.form.allocationId = this.allocationId
      this.getDetail()
    }
  },
  methods: {
    async getDetail(){
      const {allocationId} = this
      const res = await this.$API.allocationRecordDetail({
        allocationId
      })
      Object.assign(this.form,res.data.result)
      if(this.form.applyUserId){
        this.form.applyUserId = parseInt(this.form.applyUserId)
      }
      if(this.form.fileIds){
        this.fileNameLists6 = this.form.fileIds
      }
    },
    calcAmount(){
        const rows = this.$refs.waybill.getRows().filter(
          (item) => item.operationType != "DEL"
        ); 
        let amount = 0
        rows.map(item=>{
            amount = this.$TOOLS.add(amount,item.writeoffAmount || 0)
        })
        this.form.amount = amount
    },
    changeFileList6(array) {
      this.fileNameLists6 = array;
    },
    changeBusinessMan(e, refKey) {
      
    },
    async getEmps() {
      const res = await this.$API.runList({
        number: "down_list_employee",
      });
      this.emps = res;
    },
    GetAssetaccountList() {
      this.$API
        .assetaccountList({
          isSelectByLoginUser: this.readonly ? null : 1,
        })
        .then((res) => {
          if (res.data.status === "success") {
            let result = res.data.result?.data || [];
            this.account01 = result;
          } else {
            this.$message.error(`${res.data.message}`);
          }
        });
      this.$API.assetaccountList().then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result?.data || [];
          this.account02 = result;
        } else {
          this.$message.error(`${res.data.message}`);
        }
      });
    },
    getForm(){
        return {
            ...this.form,
            fileIds:this.fileNameLists6.map(item=>item.fileId),
            fundflowKeys:this.$refs.waybill.getRows()
        }
    }
  },
};
</script>

<style>
</style>